import { env } from './endpoints';

// TODO: Need to replace these values once permissions manager is deployed to other environments
const ROLE_ID = {
    QA_COMPANY_MAINTAINER_ROLE_ID: 'a72004e5-905f-4545-8969-ad6cfbdd900d',
    PPRD_COMPANY_MAINTAINER_ROLE_ID: '90d4ef86-c220-435e-90c2-af214e591f6d',
    COMPANY_MAINTAINER_ROLE_ID: '6b668c32-6ddd-4729-8046-6106e032197f'
};

export const getRoleId = () => {
    const envKey =  env ? `${ env.toLocaleUpperCase() }` + '_' : env;

    return ROLE_ID[ `${ envKey }COMPANY_MAINTAINER_ROLE_ID` ];
};

export const GOLD_COMPANY_ID = '00000000-0000-0000-0000-000000000000';

export const UK_CATALOG = 'BII (UK managed catalogs)';

export const FormLayoutOptions = {
    labelCol: {
        lg: { span: 5 },
        md: { span: 24 },
        sm: { span: 24 }
    },
    wrapperCol: {
        lg: { span: 12 },
        md: { span: 24 },
        sm: { span: 24 }
    }
};

export const supplierList = [
    {
        'value': 'BI internal (Broadleaf managed catalogs)',
        'label': 'BI internal (Broadleaf managed catalogs)'
    },
    {
        'value': 'BII (UK managed catalogs)',
        'label': 'BII (UK managed catalogs)'
    }
];
